import Input from "./input";

const MainInputs = ({ mainData, changeHandler,blurHandler }) => {
  return (
    <>
      {Object.entries(mainData).map(([key, innerObj]) => {
        console.log(key, innerObj);
        const nameWithNumberPattern = /^name.+$/;
        const linkWithNumberPattern = /^link.+$/;
        const isLinks =
          nameWithNumberPattern.test(key) || linkWithNumberPattern.test(key);
        if (!isLinks) {
          return (
            <Input
              key={key}
              id={key}
              label={key}
              control={innerObj.type}
              onChange={changeHandler}
              onBlur={blurHandler}
              valid={innerObj.isValid}
              touched={innerObj.touched}
              value={innerObj.value}
              required={innerObj.required}
              message={innerObj.message}
            />
          );
        }
      })}
    </>
  );
};

export default MainInputs;
